import { useEffect, useRef, useState } from "react";
import { Tooltip, Whisper } from "rsuite";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import DateInputStart from "../../admin/date-input-start";
import { ButtonMob } from "../../../utils/utils";
import imageDefault from "../../../assets/corporative/imageDefault.png";
import { ReactComponent as ArrowDown } from "../../../assets/elevva-pro-icons/arrowDown.svg";
import { DropdownList } from "react-widgets/cjs";

const ChallengeFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  challenge = null,
  imageUrl,
  onImageChange,
  selectedMembers,
  onMemberSelect,
  totalCustomers,
  loader
}) => {
  const styleModal = {
    display: "flex",
    position: "fixed",
    zIndex: 999,
    whiteSpace: "pre-line",
  };
  const today = new Date().toLocaleDateString("en-CA");
  const styleModalOptions = {
    display: "flex",
    position: "absolute",
    zIndex: 999,
    whiteSpace: "pre-line",
  };

  const tooltip1 = (
    <Tooltip style={{ background: "#394F65" }}>
      <div className="p-2 input-tooltip-valoration">
        <div className="pb-1">
          <span className="input-tooltip-valoration ">
            <strong>Puntaje por inscripción</strong>
          </span>
        </div>
        <p>
          Este puntaje se asigna a todos los usuarios que se inscriban al reto.
          <br />
          El puntaje final se vera afectado por eel nivel del usuario.
        </p>
      </div>
    </Tooltip>
  );
  const tooltipImage = (
    <Tooltip style={{ background: "rgb(49, 119, 190)" }}>
      <div className="p-2 input-tooltip-valoration">
        <div className="pb-1">
          <span className="input-tooltip-valoration ">
            <strong>Imagen</strong>
          </span>
        </div>
        <p>
          Selecciona una imagen para que tus atletas puedan identificar
          fácilmente este reto, aunque pueedes creear tu reto sin necesidad de
          agregar una foto.
          <br />
          Puedes agregarla después si lo deseas.
        </p>
      </div>
    </Tooltip>
  );
  const tooltip2 = (
    <Tooltip style={{ background: "#394F65" }}>
      <div className="p-2 input-tooltip-valoration">
        <div className="pb-1">
          <span className="input-tooltip-valoration ">
            <strong>Puntaje por completar el reto</strong>
          </span>
        </div>
        <p>
          Este puntaje se asigna a quienes finalicen el reto.El sistema lo
          multiplicara automaticamente segun el nivel del usuario.
          <br />
          Principiantes: x1,
          <br />
          Intermedios: x2,
          <br />
          Avanzados: x3,
          <br />
        </p>
      </div>
    </Tooltip>
  );
  const fileInputRef = useRef(null);
  const [modalFilters, setModalFilters] = useState(false);
  const [localImageUrl, setLocalImageUrl] = useState(imageUrl);
  const [localSelectedMembers, setLocalSelectedMembers] =
    useState(selectedMembers);
  const [flagAll, setFlagAll] = useState(false);
  useEffect(() => {
    setLocalImageUrl(imageUrl);
  }, [imageUrl]);

  const handleIconClick = (e) => {
    e.preventDefault();
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setLocalImageUrl(e.target.result);
        onImageChange(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="popUpServices justify-content-center align-items-center"
      style={styleModal}
    >
      <div
        className="modalInfoContenido"
        style={{
          background: "white",
          borderRadius: "20px",
          boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
          padding: "2% 6%",
          minWidth: "calc(24rem + 1vmin)",
          maxWidth: "calc(24rem + 1vmin)",
        }}
      >
        {/* Modal Header */}
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: "5%",
            fontWeight: "bold",
            fontSize: "1.5rem",
            color: " #9DACBD",
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <i className="bi bi-x-circle"></i>
        </div>

        <div className="mt-5">
          <div
            style={{
              lineHeight: "100%",
              textAlign: "center",
              color: "var(--elevvabutonLogin_User)",
            }}
          >
            Retos <strong>del centro deportivo</strong>
          </div>
        </div>

        <div
          className="mb-3 py-3"
          style={{
            lineHeight: "100%",
            textAlign: "center",
            color: "var(--elevvabutonLogin_User)",
          }}
        >
          {title} <strong>Reto</strong>
        </div>

        <PerfectScrollbar style={{ maxHeight: "70vh", padding: "0 1rem" }}>
          <form className="d-flex flex-column gap-3" onSubmit={onSubmit}>
            {/* Image Upload */}
            <div className="d-flex justify-content-center align-items-center position-relative">
              <img
                src={localImageUrl || imageDefault}
                alt="Challenge"
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
              <div style={{ left: "58%", top: "0%", position: "absolute" }}>
                <Whisper trigger="hover" placement="top" speaker={tooltipImage}>
                  <i
                    className="bi bi-question-circle-fill "
                    style={{ color: "rgb(49, 119, 190)", fontSize: "1.2rem" }}
                  ></i>
                </Whisper>
              </div>
            </div>

            <div className="position-relative">
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
              <button
                type="button"
                className="mx-auto d-flex ver_mas"
                onClick={handleIconClick}
              >
                Cambiar imagen
              </button>
            </div>

            {/* Form Fields */}
            <input
              name="name"
              className="input-style-elevva challenge-input w-100 dashboard-input"
              placeholder="Nombre del reto"
              defaultValue={challenge?.name || ""}
              required
            />

            <DateInputStart
              name="start_date"
              minDate={today}
              size={"small"}
              defaultDate={
                challenge?.start_date && title === "Editar"
                  ? new Date(challenge.start_date).toISOString().split("T")[0]
                  : null
              }
              placeholderInput="Fecha de inicio"
              disabled={
                  !!(
                      challenge?.start_date &&
                      title === "Editar" &&
                      new Date(challenge.start_date)?.toISOString()?.split("T")[0] <= today
                  )
              }
            />

            <DateInputStart
              name="end_date"
              minDate={today}
              size={"small"}
              defaultDate={
                challenge?.end_date && title === "Editar"
                  ? new Date(challenge.end_date).toISOString().split("T")[0]
                  : null
              }
              placeholderInput="Fecha de finalización"
            />

            <input
              name="reward"
              className="input-style-elevva challenge-input w-100 dashboard-input"
              style={{ fontSize: "calc(.3rem + .3vw)" }}
              placeholder="Premio"
              defaultValue={challenge?.reward || ""}
              required
            />

            <textarea
              name="description"
              className="input-style-elevva challenge-input w-100 dashboard-input"
              style={{ fontSize: "calc(.3rem + .3vw)" }}
              placeholder="Descripción"
              rows={3}
              defaultValue={challenge?.description || ""}
              required
            />

            {/* Score Inputs with Tooltips */}

            <DropdownList
              busy
              required
              name="score_for_participating"
              busySpinner={
                <Whisper trigger="hover" placement="top" speaker={tooltip1}>
                  <ArrowDown />
                </Whisper>
              }
              className={"input-style-elevva-challenge"}
              id="newScrollChallenge"
              defaultValue={
                title === "Editar" && challenge?.score_for_participating
                  ? {
                      id: challenge?.score_for_participating,
                      name: challenge?.score_for_participating,
                    }
                  : null
              }
              placeholder={"Puntaje por inscripción"}
              data={[1, 2, 3, 4, 5].map((memb) => ({
                id: memb,
                name: memb,
              }))}
              dataKey="id"
              textField="name"
              renderListItem={({ item }) => (
                <div
                  className="w-100 py-1"
                  style={{ borderBottom: "1px solid #9DACBD" }}
                >
                  <div
                    className=" dashboard-input fw-bold"
                    style={{ color: "var(--elevvaTextSubtitle)" }}
                  >
                    {item.name}
                  </div>
                </div>
              )}
            />

            <DropdownList
              required
              busy
              name="score_for_winning"
              busySpinner={
                <Whisper trigger="hover" placement="top" speaker={tooltip2}>
                  <ArrowDown />
                </Whisper>
              }
              className={"input-style-elevva-challenge"}
              id="newScrollChallenge"
              defaultValue={
                title === "Editar" && challenge?.score_for_winning
                  ? {
                      id: challenge?.score_for_winning,
                      name: challenge?.score_for_winning,
                    }
                  : null
              }
              placeholder={"Puntaje por completar el reto"}
              data={[1, 2, 3, 4, 5].map((memb) => ({
                id: memb,
                name: memb,
              }))}
              dataKey="id"
              textField="name"
              renderListItem={({ item }) => (
                <div
                  className="w-100 py-1"
                  style={{ borderBottom: "1px solid #9DACBD" }}
                >
                  <div
                    className="fw-bold dashboard-input"
                    style={{ color: "var(--elevvaTextSubtitle)" }}
                  >
                    {item.name}
                  </div>
                </div>
              )}
            />

            {/* Members Selection */}
            <div style={{ position: "relative" }}>
              <button
                type="button"
                className="w-100 d-flex add_location"
                style={{
                  padding: "0.65rem",
                  lineHeight: "1",
                  background: "white",
                  border: "1px solid var(--elevvaTextSubtitle)",
                }}
                onClick={() => setModalFilters(!modalFilters)}
              >
                <div className="d-flex align-items-center w-100 justify-content-between">
                  <span
                    style={{
                      fontSize: "calc(.33rem + .32vw)",
                      color: "var(--elevvaTextSubtitle)",
                    }}
                  >
                    {localSelectedMembers.length > 0
                      ? `${localSelectedMembers.length} usuario(s) seleccionado(s)`
                      : "Seleccionar participantes"}
                  </span>
                  <ArrowDown width={16} height={16} />
                </div>
              </button>

              {modalFilters && (
                <div
                  className="popUpFiltersChallenge"
                  style={styleModalOptions}
                >
                  <div
                    style={{
                      background: "white",
                      borderRadius: "20px",
                      boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
                      padding: "1rem",
                      width: "100%",
                      maxHeight: "300px",
                      overflowY: "auto",
                    }}
                  >
                    <div
                      className="d-flex align-items-center py-2"
                      style={{
                        borderBottom: "1px solid #9DACBD",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        let all_customer = totalCustomers?.map(
                          (customer) => customer.id
                        );
                        if (flagAll) {
                          setLocalSelectedMembers([]);
                          onMemberSelect([]);
                          setFlagAll(false);
                        } else {
                          setLocalSelectedMembers(all_customer);
                          onMemberSelect(all_customer);
                          setFlagAll(true);
                        }
                      }}
                    >
                      <input
                        type="checkbox"
                        onChange={() => {}} // Controlled by parent div click
                        style={{ marginRight: "0.5rem" }}
                      />
                      <img
                        className="ms-2 me-1"
                        style={{
                          objectFit: "cover",
                          width: "25px",
                          maxHeight: "100%",
                          maxWidth: "100%",
                          height: "25px",
                          borderRadius: "50%",
                        }}
                        src={imageDefault}
                      ></img>{" "}
                      <span style={{ fontSize: "calc(0.3rem + 0.3vw)" }}>
                        Seleccionar todos
                      </span>
                    </div>
                    {totalCustomers?.map((customer) => (
                      <div
                        key={customer.id}
                        className="d-flex align-items-center py-2"
                        style={{
                          borderBottom: "1px solid #9DACBD",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const newMembers = localSelectedMembers.includes(
                            customer.id
                          )
                            ? localSelectedMembers.filter(
                                (id) => id !== customer.id
                              )
                            : [...localSelectedMembers, customer.id];
                          setLocalSelectedMembers(newMembers);
                          onMemberSelect((prev) => {
                            if (prev.includes(customer.id)) {
                              return prev.filter((id) => id !== customer.id);
                            } else {
                              return [...prev, customer.id];
                            }
                          });
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={localSelectedMembers.includes(customer.id)}
                          onChange={() => {}} // Controlled by parent div click
                          style={{ marginRight: "0.5rem" }}
                        />
                        <img
                          className="ms-2 me-1"
                          style={{
                            objectFit: "cover",
                            width: "25px",
                            maxHeight: "100%",
                            maxWidth: "100%",
                            height: "25px",
                            borderRadius: "50%",
                          }}
                          src={
                            customer.profile_pic
                              ? customer.profile_pic
                              : imageDefault
                          }
                        ></img>{" "}
                        <span style={{ fontSize: "calc(0.3rem + 0.3vw)" }}>
                          {customer.first_name} {customer.last_name}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Submit Button */}
            <div className="col-12 btnAction_pruebas letraspopfi2">
              <ButtonMob
                type="submit"
                colorButton="var(--elevvabutonLogin_User)"
                text="Guardar"
                className="mb-3 mt-3 letraspopfi2actualizar"
                disabled={loader}
              />
            </div>
          </form>
        </PerfectScrollbar>
      </div>
    </div>
  );
};
export default ChallengeFormModal;
